module.exports = __webpack_public_path__ + "img/cvwo.209df976.jpeg";